<template>
  <div id="truck">

    <!-- * Title -->
    <div class="title">
      <icon icoClass='title-ico' selected='trucks'/> {{ (id || truck.id) ? $t('edit_truck') : $t('trucks_sign_up') }}
    </div>

    <!-- * Form Fields -->
    <div class="fields">
      <div class="field">
        <label>{{ $t('plate') }}</label>
        <search-input
          inputStyle="box-sizing: border-box"
          placeholder="XXXX-AAA"
          width="100%"
          basePath="shipper/autocomplete_plate"
          filter='plate'
          v-model="truck.plate"
          @data="handlePlateSelection"
          :uppercase="true"
        />
      </div>
      <div class="field">
        <label>{{ $t('name') }}</label>
        <search-input
          inputStyle="box-sizing: border-box"
          placeholder="AAXXXXXX"
          width="100%"
          basePath="shipper/autocomplete_name"
          filter='name'
          v-model="truck.name"
          @data="truck.name=$event"
          :uppercase="true"
        />
      </div>
      <div class="field" v-if="!auth.isTrw">
        <label>{{ $t('capacity_load') }}</label>
        <input type="text" v-model="truck.capacity_load" @input="truck.capacity_load = $event.target.value.replace(/\D/g, '')"/>
      </div>
      <div class="field" v-if="auth.hasSms">
        <label>{{ $t('phone') }}</label>
        <div class="active">
          <vue-country-code @onSelect="onSelect" height="50%" :preferredCountries="['es', 'pt', 'gb', 'mx']" ></vue-country-code>
          <search-input
            inputStyle="box-sizing: border-box"
            placeholder="XXX-XXXXXXX"
            width="100%"
            basePath="shipper/autocomplete_phone"
            filter='phone'
            :defaultFilter="phoneFilters"
            v-model="truck.phone"
            @data="truck.phone=$event;"
          />
        </div>
      </div>

      <!-- * Buttons -->
      <div class="buttons">
        <button class="btn-green" @click="save()">{{ $t('save') }}</button>
        <button class="btn-black" @click="$emit('cancel')">{{ $t('cancel') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import SearchInput from '@/components/SearchInput'
import {mapActions, mapState} from 'vuex'
import icon from './../svg/tabs'
export default {
  name: 'truck-form',
  components: {
    SearchInput,
    icon
  },
  props: ['id'],
  created () {
    this.$emit('loading')
  },
  mounted () {
    this.getTruckInfo()
  },
  data () {
    return {
      plates: [],
      names: [],
      truck: {
        capacity_load: '',
        country_code: '',
        plate: '',
        phone: '',
        name: ''
      },

      currentQueryId: 0
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth
    }),
    phoneFilters: {
      get: function () {
        return {name: this.truck.name, plate: this.truck.plate}
      }
    }
  },
  watch: {
    id () {
      if (this.id) this.getTruck(this.id).then(response => { this.truck = response })
    }
  },
  methods: {
    ...mapActions({
      getPlates: 'trucks/getPlates',
      getNames: 'trucks/getNames',
      saveTruck: 'trucks/save',
      getTruck: 'trucks/read'
    }),
    save () {
      this.truck.company = this.truck.company || this.auth.company

      const data = {
        ...this.truck,
        capacity_load: this.truck.capacity_load === '' ? null : this.truck.capacity_load
      }

      this.saveTruck(data).then(response => { this.$emit('save', response) })
    },
    onSelect ({dialCode}) {
      this.truck.country_code = dialCode
    },

    // Async methods
    async getInitialData () {
      this.truck = this.id ? await this.getTruck(this.id) : this.truck
      this.names = this.truck.name ? await this.getNames() : this.names
      this.plates = this.truck.plate ? await this.getPlates() : this.plates
    },
    async getTruckInfo () {
      try {
        await this.getInitialData()
      } catch (error) {
        console.error('Error checking permissions and company:', error)
      } finally {
        this.$emit('loaded')
      }
    },
    async handlePlateSelection (plate) {
      try {
        const response = await this.getPlates({ plate: this.truck.plate })
        if (response.shipper) {
          this.truck.id = response.shipper.id
          this.truck.name = response.shipper.name || this.truck.name
          this.truck.plate = response.shipper.plate || this.truck.plate
          this.truck.capacity_load = response.shipper.capacity_load || this.truck.capacity_load
          this.truck.country_code = response.shipper.country_code || this.truck.country_code
          this.truck.phone = response.shipper.phone || this.truck.phone
        }
      } catch (e) {
        console.error('Error fetching plates:', e)
      }
    }
  }
}
</script>

<style scoped lang="scss">
#truck {
  gap: 2rem;
  padding: 2rem;
  background-color: #f9f9f9;
  border-radius: 1rem;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.1);
}
input, .input-class{
  width: 100%;
  box-sizing: border-box;
}
.fields {
  padding: 0 3em;
}
.buttons {
  display: flex;
  justify-content: center;
  margin-top: 1em;
  gap: 10px;
  .btn-green:hover {
    background-color: #e8ee8f;
  }
  .btn-blue:hover {
    background-color: #5ab9b9;
  }
  .btn-black:hover {
    background-color: #5e5e5e;
  }
}
.vue-country-select {
  border: 2px #D1D1D1 solid;
  border-radius: .3em 0px 0px .3em;
  height: 29px;
}
.active {
  display: grid;
  grid-template-columns: 15% 85%;
}
.input-search {
  box-sizing: border-box
}
</style>



// WEBPACK FOOTER //
// src/components/Truck.vue